<div class="infigoContain">
    <section class="infigo-init-panel">
        <div *ngIf="checkShowNAS()||checkShowSAN()" class="left-panel">
            <div class="panel-container container-item">
                <div *ngIf="checkShowSAN()" class="resource-item">
                    <div class="resource-title">{{i18n.get('home.search_term_sanResource_lab')}}</div>
                    <div class="svg-panel">
                        <app-san-resource (selectedResource)="handleSelectedResource($event)"></app-san-resource>
                    </div>
                </div>
                <div *ngIf="checkShowNAS()" class="resource-item">
                    <div class="resource-title">{{i18n.get('home.search_term_nasResource_lab')}}</div>
                    <div class="svg-panel">
                        <app-nas-resource (selectedResource)="handleSelectedResource($event)"></app-nas-resource>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="checkShowNAS()||checkShowSAN()" class="line"></div>
        <div class="main-panel">
            <div class="panel-container">
                <div class="container-item">
                    <app-history-list
                        (selectSearchItem)="handleSearchObject($event)"
                        [listConfig]="recommendConfig"
                        [listData]="recommendList"
                        classify="true"
                    ></app-history-list>
                    <app-history-list
                        (selectSearchItem)="handleJumpToPage($event)"
                        [listConfig]="commonConfig"
                        [listData]="commonList"
                        classify="true"
                    ></app-history-list>
                    <div class="last-col">
                        <app-history-list
                            (selectSearchItem)="handleSearchObject($event)"
                            [listConfig]="latestConfig"
                            [listData]="latestList"
                        ></app-history-list>
                        <app-history-list
                            (removeSelectedItem)="removeCollectedItem($event)"
                            (selectSearchItem)="handleSearchObject($event)"
                            [listConfig]="collectedConfig"
                            [listData]="collectList"
                        ></app-history-list>
                    </div>
                </div>
            </div>
        </div>
        <div class="line"></div>
        <div class="right-panel">
            <div class="panel-container">
                <div class="help-item" *ngIf="newFeatureList.length">
                    <div class="help-title">{{i18n.get('home.search_term_functionUpdate_lab')}}</div>
                    <div class="carousel-panel">
                        <app-carousel [list]="newFeatureList"></app-carousel>
                    </div>
                </div>
                <!--  微存储屏蔽快速入门-->
                <div class="help-item" *ngIf="FeatureConfig.IsSupportOpenQuickStart">
                    <div class="help-title">{{i18n.get('home.search_term_quickStart_lab')}}</div>
                    <div class="carousel-panel">
                        <app-carousel [list]="quickStartList"></app-carousel>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
